import React, { useContext } from 'react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import { Modal, IconButton, PrimaryButton, MessageBar, MessageBarType, Link, mergeStyleSets, FontSizes, FontWeights, NeutralColors } from '@fluentui/react';

import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';

const PARTNERS_URL = 'https://aka.ms/mc4n-partners';

export const DeprecationModal = () => {
	const { t } = useContext(TranslationsContext)!;
	const [isOpen, { setFalse: hideModal }] = useBoolean(true);
	const titleId = useId('deprecation-modal-title');
	const subtitleId = useId('deprecation-modal-subtitle');

	return (
		<Modal
			isOpen={isOpen}
			onDismiss={hideModal}
			containerClassName={styles.container}
			titleAriaId={titleId}
			subtitleAriaId={subtitleId}
		>
			<div className={styles.body}>
				<IconButton
					className={styles.closeButton}
					iconProps={{ iconName: 'Cancel' }}
					ariaLabel={t(translationKeys.DeprecationModal.CloseButton.AriaLabel)}
					onClick={hideModal}
				/>
				<MessageBar messageBarType={MessageBarType.severeWarning} className={styles.banner} isMultiline>
					{t(translationKeys.DeprecationModal.Banner.Text)}
					<strong className={styles.bannerDate}>{t(translationKeys.DeprecationModal.Banner.Date)}</strong>.
				</MessageBar>
				<h2 id={titleId} className={styles.title}>{t(translationKeys.DeprecationModal.Title)}</h2>
				<p id={subtitleId} className={styles.paragraph}>{t(translationKeys.DeprecationModal.Intro)}</p>
				<h3 className={styles.subtitle}>{t(translationKeys.DeprecationModal.NextSteps.Title)}</h3>
				<p className={styles.paragraph}>{t(translationKeys.DeprecationModal.NextSteps.Paragraph)}</p>
				<p className={styles.partnerLine}>
					{t(translationKeys.DeprecationModal.NextSteps.PartnerText)}
					<Link href={PARTNERS_URL} target="_blank" rel="noopener noreferrer">
						{t(translationKeys.DeprecationModal.NextSteps.PartnerLinkText)}
					</Link>
				</p>

				<div className={styles.footer}>
					<PrimaryButton onClick={hideModal} text={t(translationKeys.DeprecationModal.AcknowledgeButton.Text)} />
				</div>
			</div>
		</Modal>
	);
};

const styles = mergeStyleSets({
	container: {
		maxWidth: '640px',
		width: '100%',
		margin: '1.25rem',
		borderRadius: '2px'
	},
	body: {
		position: 'relative',
		padding: '2.5rem 2rem 2rem 2rem'
	},
	closeButton: {
		position: 'absolute',
		top: '0.5rem',
		right: '0.5rem',
		color: NeutralColors.gray160
	},
	banner: {
		marginBottom: '1.5rem',
		borderRadius: '2px'
	},
	bannerDate: {
		fontWeight: FontWeights.semibold
	},
	title: {
		fontSize: FontSizes.size24,
		fontWeight: FontWeights.semibold,
		margin: '0 0 1rem 0'
	},
	subtitle: {
		fontSize: FontSizes.size18,
		fontWeight: FontWeights.semibold,
		margin: '1rem 0 0.5rem 0'
	},
	paragraph: {
		fontSize: FontSizes.size14,
		color: NeutralColors.gray160,
		margin: '0 0 0.5rem 0',
		lineHeight: '1.5'
	},
	partnerLine: {
		fontSize: FontSizes.size14,
		color: NeutralColors.gray160,
		margin: '0 0 0.5rem 0',
		lineHeight: '1.5',
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'baseline',
		columnGap: '0.25rem'
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: '1.5rem'
	}
});
